<template>
    <div>
        <v-layout wrap>
            <v-flex xs12 >
                <v-layout row >
                    <v-flex xs3 mr-1>
                        <!--stat numerique-->
                        <v-layout  wrap >
                            <v-flex mb-3 xs12 >
                                <v-card color="cyan darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs7>
                                                <div>
                                                    <div class="display-1">
                                                        <v-icon dark>assignment</v-icon>
                                                        {{infoEmploye.congeVacance}}
                                                    </div>
                                                    <div>Congé vacances(Jrs)</div>
                                                </div>
                                            </v-flex>
                                            <!--<v-flex xs6>-->
                                            <!--<div>Congé vacance</div>-->
                                            <!--<div class="display-1">{{infoEmploye.congeVacance}}</div>-->
                                            <!--</v-flex>-->
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>
                            <v-flex mb-3 xs12 >
                                <v-card color="orange darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs5>
                                                <div>
                                                    <div class="headline">
                                                        <v-icon dark>assignment</v-icon>
                                                        {{infoEmploye.congeFam}}</div>
                                                    <div>Congé familiaux et medicaux(Jrs)</div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs7>
                                                <div>Deuil(Jrs)</div>
                                                <div class="display-3">{{infoEmploye.congeDeuil}}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>
                            <v-flex mb-3 xs12  >
                                <v-card color="red darken-2" class="white--text elevation-5">
                                    <v-container fluid grid-list-lg>
                                        <v-layout row>
                                            <v-flex xs5>
                                                <div>
                                                    <div class="headline">
                                                        <v-icon dark>assignment</v-icon>
                                                        {{infoEmploye.congeMariage}}
                                                    </div>
                                                    <div>Mariage(Jrs)</div>
                                                </div>
                                            </v-flex>
                                            <v-flex xs7>
                                                <div>Autre(Jrs)</div>
                                                <div class="display-3">{{infoEmploye.congeAutre}}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <!--fin stat numerique-->

                    </v-flex>


                    <v-flex xs9 ml-3>
                        <!--Info employe-->
                        <v-card>
                            <v-toolbar class="text-xs-center"   color="blue-grey darken-2" dark>
                                <v-toolbar-title>Informations personnelles </v-toolbar-title>
                            </v-toolbar>
                            <v-card-title>
                                <v-layout row class="mb-2 mt-2  pt-2 pb-2 pl-2 pr-2" >
                                    <v-flex xs2 class="text-xs-center">
                                        <v-avatar  class="elevation-4" :tile="true" size="140px" height="140px" color="grey lighten-4">
                                            <img :src="infoEmploye.urlAvatar"  alt="avatar">
                                        </v-avatar>
                                        <v-btn
                                                small
                                                color="primary"
                                                class="white--text"
                                                @click="showDetailPerso()"
                                        >
                                            Modifier
                                            <v-icon right dark>edit</v-icon>
                                        </v-btn>
                                    </v-flex>

                                    <v-flex xs10  >
                                        <v-layout row wrap>
                                            <!--info employe-->


                                            <v-flex xs12>
                                                <v-layout row>
                                                    <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                        <v-layout wrap>
                                                            <v-flex xs12>
                                                                <v-layout row>
                                                                    <v-flex xs6>Nom</v-flex>
                                                                    <v-flex xs6 class="text-xs-right title">
                                                                        {{infoEmploye.nom}}
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-divider class="mb-3"></v-divider>

                                                                <v-layout row>
                                                                    <v-flex xs6>Date naissance</v-flex>
                                                                    <v-flex xs6 class="text-xs-right title">
                                                                        {{infoEmploye.dateNaissance}}
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-divider class="mb-3"></v-divider>

                                                                <v-layout row>
                                                                    <v-flex xs6>Sexe</v-flex>
                                                                    <v-flex xs6 class="text-xs-right title">
                                                                        {{infoEmploye.sexe}}
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-divider class="mb-3"></v-divider>

                                                                <v-layout row>
                                                                    <v-flex xs6>Contact</v-flex>
                                                                    <v-flex xs6 class="text-xs-right title">
                                                                        {{infoEmploye.contact}}
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-divider class="mb-3"></v-divider>


                                                                <v-layout row>
                                                                    <v-flex xs6>Rénumération</v-flex>
                                                                    <v-flex xs6 class="text-xs-right title">
                                                                        {{ new Intl.NumberFormat().format(infoEmploye.renumeration)}}
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-divider class="mb-3"></v-divider>

                                                                <v-layout row>
                                                                    <v-flex xs6>Etat du contrat</v-flex>
                                                                    <v-flex xs6 class="text-xs-right title">
                                                                        <el-tag v-if="infoEmploye.etatContrat == 0" type="success">{{infoEmploye.libEtatContrat}}</el-tag>
                                                                        <el-tag v-else type="danger">{{infoEmploye.libEtatContrat}}</el-tag>

                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-divider class="mb-3"></v-divider>
                                                              <v-layout row>
                                                              <v-flex xs2>Signature</v-flex>
                                                              <v-flex xs10 class="text-xs-right title">
                                                                   <img :src="infoEmploye.urlSign"  style="height: 95px; width:300px ;" alt="avatar">
                                                            </v-flex>
                                                        </v-layout>


                                                                <!-- <v-layout row>
                                                                    <v-flex xs2>Signature: </v-flex>
                                                                    <v-avatar  class="elevation-4" :tile="true" size="300px" height="70px" color="grey lighten-4">
                                                                        <img :src="infoEmploye.urlSignature"  alt="avatar">
                                                                    </v-avatar>
                                                                </v-layout> -->
                                                            </v-flex>
                                                        </v-layout>


                                                    </v-flex>

                                                    <v-flex xs6> <!--COLONNE 2-->
                                                        <v-layout row>
                                                            <v-flex xs6>Nb contrat(s)</v-flex>
                                                            <v-flex xs6 class="text-xs-right title">
                                                                {{infoEmploye.nbCont}}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="mb-3"></v-divider>
                                                        <v-layout row>
                                                            <v-flex xs6>Type contrat</v-flex>
                                                            <v-flex xs6 class="text-xs-right title">
                                                                {{infoEmploye.typeContrat}}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="mb-3"></v-divider>
                                                        <v-layout row>
                                                            <v-flex xs6>Civilté</v-flex>
                                                            <v-flex xs6 class="text-xs-right title">
                                                                {{infoEmploye.civilite}}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="mb-3"></v-divider>

                                                        <v-layout row>
                                                            <v-flex xs6>Matricule</v-flex>
                                                            <v-flex xs6 class="text-xs-right title">
                                                                {{infoEmploye.matricule}}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="mb-3"></v-divider>

                                                        <v-layout row>
                                                            <v-flex xs6>Numéro CNPS</v-flex>
                                                            <v-flex xs6 class="text-xs-right title">
                                                                {{infoEmploye.matriculeCnps}}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="mb-3"></v-divider>

                                                        <v-layout row>
                                                            <v-flex xs6>Fonction</v-flex>
                                                            <v-flex xs6 class="text-xs-right title">
                                                                {{infoEmploye.fonction}}
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider class="mb-3"></v-divider>

                                                        <v-layout row>
                                                            <v-flex xs2>Adresse</v-flex>
                                                            <v-flex xs10 class="text-xs-right title">
                                                                <el-input
                                                                        type="textarea"
                                                                        :rows="4"
                                                                        :readonly="true"
                                                                        placeholder="Adresse"
                                                                        v-model="infoEmploye.adresse">
                                                                </el-input>
                                                            </v-flex>

                                                        </v-layout>


                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <!--fin info employe-->
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>

                        <!--fin Info employe-->
                    </v-flex>
                </v-layout>
            </v-flex>


            <v-flex xs12>
                <v-layout row >
                    <v-layout row >
                        <v-flex xs12 ml-1 mr-1 mt-1>
                            <v-card>
                                <v-toolbar class="text-xs-center"   color="blue-grey darken-2" dark>
                                    <v-toolbar-title>Informations professionnelles</v-toolbar-title>
                                </v-toolbar>
                                <v-card-title >
                                    <el-tabs style="width:100%;"  v-model="onglet" type="border-card" @tab-click="handleTabClick(onglet)" >

                                        <el-tab-pane label="Mes Contrats">
                                            <contratEmploye :typeAdmin="admin" :idUserContrat="idUserCont"></contratEmploye>
                                        </el-tab-pane>


                                        <el-tab-pane label="Detail professionnel" style="width:100%;">
                                            <detailProfessionnel :typeAdmin="admin" :show="onglet == '1'" :idUserEmploye="idUserCont"></detailProfessionnel>
                                        </el-tab-pane>


                                        <el-tab-pane  label="les demandes d'absences" style="width:100%;" >
                                            <div style="width:100%;">
                                                <span class="title">Liste des demandes de congés de l'année en cours</span>
                                                <v-divider class="mb-3"></v-divider>
                                                <v-layout row wrap >

                                                    <v-flex  v-show="admin == false"  xs12 class="text-xs-right">
                                                        <v-tooltip bottom>
                                                            <v-btn :disabled="demandeEnAttente" slot="activator" color="primary" @click="showFormDmd()" >
                                                                Créer
                                                                <v-icon dark right>add</v-icon>
                                                            </v-btn>
                                                            Créer un demande d'absence
                                                        </v-tooltip>

                                                    </v-flex>
                                                   <v-flex xs12 class="text-xs-right">
                                                    <v-tooltip bottom>
                                                        <v-btn class="elevation-3" slot="activator" @click="loadListeAbsence()" dark icon flat color="primary">
                                                            <v-icon>cached</v-icon>
                                                        </v-btn>
                                                        actualiser la liste
                                                    </v-tooltip>
                                                  </v-flex>


                                                    <v-flex xs12>

                                                        <v-alert
                                                                v-if="demandeEnAttente"
                                                                class="elevation-4 subheading mb-3"
                                                                :value="true"
                                                                color="warning"
                                                                icon="priority_high"
                                                                outline
                                                        >
                                                            Vous avez une demande d'absence en attente de validation, vous devez patientez jusqu'a la validation de celle-ci avant de faire une autre demande
                                                        </v-alert>
                                                        <data-tables :data="listeAbsence" style="width:100%" >
                                                            <el-table-column type="expand">
                                                                <template slot-scope="props">
                                                                    <v-layout wrap class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4">

                                                                        <v-flex xs12>
                                                                            <v-layout row>
                                                                                <v-flex xs6>
                                                                                    <span class="title">Validateur demande d'absence</span>
                                                                                    <v-divider></v-divider>
                                                                                    <el-table
                                                                                            :data="props.row.validationDmd"
                                                                                            stripe
                                                                                            style="width: 100%">
                                                                                        <el-table-column
                                                                                                prop="responsable"
                                                                                                label="Responsable"
                                                                                                width="180">
                                                                                        </el-table-column>

                                                                                        <el-table-column
                                                                                                prop="statut"
                                                                                                label="Statut"
                                                                                                width="220">
                                                                                            <template slot-scope="scope">
                                                                                                <span class="cyan--text body-2">{{scope.row.statut}}</span>
                                                                                            </template>
                                                                                        </el-table-column>

                                                                                        <el-table-column
                                                                                                prop="dateValidation"
                                                                                                label="date de validation">
                                                                                        </el-table-column>

                                                                                    </el-table>
                                                                                </v-flex>

                                                                                <v-flex xs3 ml-2>
                                                                                    <div class="grid-content">
                                                                                        <p class="title">Description</p>
                                                                                        <v-divider></v-divider>
                                                                                    </div>
                                                                                    <div class="grid-content">
                                                                                        <el-input
                                                                                                type="textarea"
                                                                                                :rows="5"
                                                                                                :disabled="false"
                                                                                                readonly="true"
                                                                                                placeholder="Description"
                                                                                                v-model="props.row.description">
                                                                                        </el-input>
                                                                                    </div>
                                                                                </v-flex>
                                                                                <v-flex xs3 ml-2>
                                                                                    <div class="grid-content">
                                                                                        <p class="title">Motif de refus</p>
                                                                                        <v-divider></v-divider>
                                                                                    </div>
                                                                                    <div class="grid-content">
                                                                                        <el-input
                                                                                                type="textarea"
                                                                                                :rows="5"
                                                                                                :disabled="false"
                                                                                                readonly="true"
                                                                                                placeholder="Motif de refus"
                                                                                                v-model="props.row.descRefus">
                                                                                        </el-input>
                                                                                    </div>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column   prop="dateDbt" label="DATE DEBUT" align="left"></el-table-column>
                                                            <el-table-column  prop="dateFin" label="DATE FIN"  align="left"></el-table-column>
                                                            <el-table-column  prop="dateRetour" label="DATE RETOUR"  align="left"></el-table-column>
                                                            <el-table-column  prop="typeConge" label="TYPE CONGE" align="left">
                                                                <template slot-scope="scope">
                                                                    <el-tag>{{scope.row.typeConge}}</el-tag>
                                                                </template>
                                                            </el-table-column>

                                                            <el-table-column width="180"  prop="status" label="STATUT" align="left">
                                                                <template slot-scope="scope" >
                                                                    <el-tag   v-if="scope.row.status == 'En cours de traitement'" >{{scope.row.status}}</el-tag>
                                                                    <el-tag   v-else-if="scope.row.status == 'En Attente de validation par DG'"  type="warning">{{scope.row.status}}</el-tag>
                                                                    <el-tag   v-else-if="scope.row.status == 'Refusé par la DRH'"  type="danger">{{scope.row.status}}</el-tag>
                                                                    <el-tag   v-else-if="scope.row.status == 'Validée par DG'"  type="success">{{scope.row.status}}</el-tag>
                                                                    <el-tag   v-else-if="scope.row.status == 'Refusé le DG'"  type="danger">{{scope.row.status}}</el-tag>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="FICHIER" align="center" width="100" >
                                                                <template slot-scope="scope">
                                                                    <v-tooltip bottom>
                                                                        <v-avatar
                                                                                slot="activator"
                                                                                v-for="(image, imageIndex) in scope.row.imagesAbs"
                                                                                :key="imageIndex"
                                                                                @click="showDiapo(scope.row.imagesAbs,imageIndex)"
                                                                                :style="{ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}"
                                                                                :tile=true
                                                                                :size="50"
                                                                                color="grey lighten-4"
                                                                                class="mb-1 mr-1 elevation-3"
                                                                        >
                                                                            <img :src="image" alt="avatar">
                                                                        </v-avatar>
                                                                        Cliquez pour agrandir
                                                                    </v-tooltip>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="ACTION" align="center"  width="180" >
                                                                <template slot-scope="scope" >
                                                                    <v-tooltip bottom  v-if="scope.row.status =='Validée par DG'">
                                                                        <v-btn  @click.native="imprimerDemande(scope.row)" slot="activator" color="orange" fab dark small>
                                                                            <v-icon>print</v-icon>
                                                                        </v-btn>
                                                                        Imprimer votre autorisation
                                                                    </v-tooltip>

                                                                    <v-tooltip bottom v-if="admin == true && !scope.row.retourIsPossible">
                                                                        <v-btn @click.native="showDialogRetour(scope.row.idAbsence)" slot="activator" color="purple" fab small class="white--text">
                                                                            <v-icon>swap_vert</v-icon>
                                                                        </v-btn>
                                                                        Retour de congé
                                                                    </v-tooltip>

                                                                    <v-tooltip bottom>
                                                                        <v-btn v-if="scope.row.idStatus == 0"  @click.native="showSuppAbs(scope.row.idAbsence)" slot="activator" color="red" icon fab dark small>
                                                                            <v-icon>delete</v-icon>
                                                                        </v-btn>
                                                                        Supprimer
                                                                    </v-tooltip>

                                                                </template>
                                                            </el-table-column>
                                                        </data-tables>
                                                    </v-flex>
                                                </v-layout>
                                            </div>


                                        </el-tab-pane>

                                    </el-tabs>
                                </v-card-title>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-layout>

            </v-flex>
        </v-layout>

        <!--DIALOG FORM DEMANDE ABSENCE-->
        <v-dialog v-model="dialogFormDmdAbsence" width="60%" hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Effectuer une demande d'absence</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="dialogFormDmdAbsence = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-layout row class="text-xs-center">
                    <v-flex xs12>
                        <formAbsence @close="closeFormAbs()"></formAbsence>
                    </v-flex>
                </v-layout>

            </v-card>
        </v-dialog>
        <!--DIALOG FORM DEMANDE ABSENCE-->

        <formEditUser @close="closeFormUser()" :show="showDialogPerso" :idEmploye="idUserCont"></formEditUser>
        <!--DIALOG SUPP DEMANDE-->
        <v-dialog
                v-model="dialogSuppAbs"
                max-width="550"
        >
            <v-card>
                <v-card-title class="headline">

                    <el-alert
                            title="Voulez-vous supprimer cette demande ?"
                            type="warning"
                            :closable="false"
                            show-icon>
                    </el-alert>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="grey darken-1"
                            flat="flat"
                            @click="dialogSuppAbs = false"
                    >
                        Annuler
                    </v-btn>

                    <v-btn
                            color="red darken-1"
                            dark
                            @click="submitSuppAbs()"
                    >
                        Supprimer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!--DIALOG FORM RETOUR ABSENCE-->
        <v-dialog v-model="dialogRetourAbs" width="40%" hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Confirmer la présence de l'employé</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon dark @click="dialogRetourAbs = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <v-layout row >
                        <v-flex xs12>
                            <el-form ref="formRetourAbs"  :model="formRetourAbs" class="demo-form-inline">
                                <el-row type="flex" :gutter="20" >
                                    <el-col :span="14">
                                        <div class="block">
                                            <el-form-item label="Date retour">
                                                <el-date-picker
                                                        v-model="formRetourAbs.dateRetour"
                                                        type="datetime"
                                                        format="dd-MM-yyyy HH:mm:ss"
                                                        placeholder="Selectionnez date et horaire">
                                                    >
                                                </el-date-picker>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                </el-row>

                                <el-row type="flex" justify="center">
                                    <el-col :span="24">

                                        <el-form-item style="width:97%" label="Description">
                                            <el-input type="textarea" :rows="6" v-model="formRetourAbs.desc"></el-input>
                                        </el-form-item>

                                    </el-col>
                                </el-row>



                                <el-row type="flex" :gutter="20"  justify="end">
                                    <el-col :span="6" >
                                        <div style="width:100%" class="mt-4">
                                            <v-tooltip top>
                                                <v-btn
                                                        :disabled="!formRetourIsValid"
                                                        slot="activator"
                                                        class="white--text"
                                                        color="green"
                                                        @click="submitFormRetour()"
                                                >

                                                    Enregistrer
                                                    <v-icon right>save</v-icon>
                                                </v-btn>
                                                enregistrer
                                            </v-tooltip>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </v-flex>
                    </v-layout>
                </v-card-text>


            </v-card>
        </v-dialog>

        <CoolLightBox
                :items="items"
                :index="index"
                @close="index = null"
        >

        </CoolLightBox>
    </div>
</template>

<script>
    import formAbsence from '@/components/resourceHumaine/form_absence';
    import contratEmploye from '@/components/resourceHumaine/contrat_employe';
    import detailProfessionnel from '@/components/resourceHumaine/detail_professionnel';
    import Loading from '@/components/Loading';
    import formEditUser from '@/components/resourceHumaine/form_edit_user';
    export default {
        props: {
            idUserCont:{
                type: Number,
                //default: 8
            },
            showEmpl:{
                type: Boolean,
                default: false
            },
            admin:{
                type: Boolean,
                default: true
            }
        },
        components: {formAbsence,formEditUser,Loading,contratEmploye,detailProfessionnel},
        name: "detailEmploye",
        data()
        {
            return{
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                loading: false,
                loadingAbsence: false,

                //data
                onglet: "0",
                infoEmploye: {},
                detailProfession: [],
                listeContrats:[],
                listeAbsence:[],
                dialogFormDmdAbsence: false,
                showDialogPerso: false,
                idAbsenceSelect: null,
                dialogSuppAbs: false,
                demandeEnAttente: false,
                items: [],
                index: null,

                //DIALOG RETOUR
                dialogRetourAbs: false,
                formRetourAbs:{},
                dateNow: new Date()

            }
        },

        watch: {
            showEmpl: function(newValue,oldValue){
                if(newValue == true)
                {
                    this.onglet = "0";
                    this.detailProfession.splice(0);
                    this.listeContrats.splice(0);
                    this.listeAbsence.splice(0);
                    this.loadInfo();
                }
            }
        },

        computed:{
            formRetourIsValid(){

                if(this.formRetourAbs.dateRetour == null || (this.formRetourAbs.desc == "" || this.formRetourAbs.desc == undefined ) ) {
                    return false;
                }
                else {
                    return true;
                }
            },

        },


        methods: {
            submitFormRetour(){
                this.loading = true;
                let url = this.domaine + 'rh/absence/'+this.idAbsenceSelect +"/retour"
                let data = new FormData();
                data.append("dataForm", JSON.stringify(this.formRetourAbs))
                data.append("userCreated", this.user.id)

                this.$http.post(url,data).then(response => {
                        this.loading = false
                        this.resetForm('formRetourAbs')
                        this.dialogRetourAbs = false
                        this.listeAbsence.splice(0)
                        this.loadListeAbsence()
                        this.successNotif(response.body.message)

                    },
                    error =>{
                        this.loading = false;
                        this.$message.error("Echec lors de l'enregistrement")
                    })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    type: 'success',
                    position: 'top-center'
                })
            },
            showDialogRetour(idAbs){
                this.dialogRetourAbs = true
                this.idAbsenceSelect = idAbs
            },
            showDiapo(images, ind){
                this.items = images
                this.index = ind;
            },
            showSuppAbs(idAbsence){
                this.idAbsenceSelect = idAbsence;
                this.dialogSuppAbs = true;
            },
            loadInfo(){
                this.loading = true;
                let url = this.domaine+"userCreate/infoUser/"+this.idUserCont
                this.$http.get(url).then(resp => {
                    this.infoEmploye = resp.body.employe
                }, error =>{
                    this.loading = false
                    this.$message.error("Echec lors du chargement des informations utilisateurs")
                })
            },
            closeFormUser(){
                this.showDialogPerso = false;
                this.loadInfo();
            },
            showDetailPerso(){
                this.showDialogPerso = true;

            },
            handleTabClick(onglet)
            {
                console.log("handle click", onglet)
                switch (onglet){
                    case "1": //Detail professionnel
                        //this.loadListeAbsence()
                        break
                    case "2": //liste demande
                        this.loadListeAbsence()
                        break
                }
            },
            imprimerDemande(item) {
                console.log('item',item)
                let url = this.domaine + 'impr/impression/user/'+this.idUserCont+'/demande/'+item.idAbsence+'/conge';
                window.open(url)
            },
            showFormDmd(){
                this.dialogFormDmdAbsence = true
            },
            closeFormAbs(){
                this.dialogFormDmdAbsence = false;
                this.listeAbsence.splice(0);
                this.loadListeAbsence()
            },
            loadListeAbsence(){
                this.loading = true;
                this.loadingAbsence = true
                if(this.listeAbsence.length > 0){
                    return;
                }
                this.loadingAbsence = true;
                let url = this.domaine + 'rh/listeAbsence/'+this.idUserCont
                this.$http.get(url).then(response => {
                    this.loading = false;
                    this.loadingAbsence = false
                    this.listeAbsence = response.body.listeAbsences
                    this.demandeEnAttente = response.body.dmdEnAttente;
                    this.loadingAbsence = false
                },
                error =>{
                    this.loadingAbsence = false
                    this.$message.error("Echec lors du chargement de la liste des demandes absences")
                })
            },
            submitSuppAbs(){
                this.loading = true;
                let url = this.domaine+"rh/absence/"+this.idAbsenceSelect+"/delete";
                this.$http.get(url).then( resp =>
                    {
                        this.loading = false;
                        this.dialogSuppAbs = false;
                        this.listeAbsence.splice(0);
                        this.loadListeAbsence()
                        this.successNotif(response.body.message)
                    },
                    error=>
                    {
                        this.loading = false;
                        this.dialogSuppAbs = false;
                        this.$message.error("Echec lors de la suppression de la demande")
                    });
            }
        }
    }


</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/resourceHumaine/detail_employe.vue